import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50091731"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "本条信息已不存在", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "用户下架或已被删除", -1))
const _hoisted_4 = { class: "btn" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("我知道了")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createBlock(_component_VanPopup, {
    class: "DataDoesNotExist",
    show: $setup.props.modelValue,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (($setup.props.modelValue) = $event)),
    style: {"border-radius":"8px","overflow":"hidden"},
    "close-on-click-overlay": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_VanImage, {
          src: require("@/assets/img/contentDoesNotExist.png"),
          width: "6rem"
        }, null, 8, ["src"]),
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_VanButton, {
            block: "",
            round: "",
            color: "#FFCC32",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.back()))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}